/* Package and colour controls reuse Shrine's variant selection and product form. */
if (!customElements.get('jupityr-package-choice')) {
  customElements.define('jupityr-package-choice', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.input = this.querySelector('input[type="radio"]');
      this.addEventListener('change', () => {
        const picker = document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`);
        const native = [...(picker?.querySelectorAll('input[type="radio"]') || [])].find(input => input.value === this.input.dataset.optionValue);
        if (!native || this.input.disabled) return;
        native.checked = true;
        native.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: this.events.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe?.();
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data?.sectionId) === this.dataset.section && data.variant) this.input.checked = this.input.value === String(data.variant.id);
        });
      }
    }
    disconnectedCallback() { this.events?.abort(); this.unsubscribe?.(); }
  });
}
if (!customElements.get('jupityr-dock-selector')) {
  customElements.define('jupityr-dock-selector', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.label = this.querySelector('.jupityr-dock-selection');
      this.dock = this.closest('sticky-atc');
      this.addEventListener('change', event => {
        if ((this.dataset.nativeColours === 'true' && event.target.closest('.jupityr-dock-finishes'))
            || (this.dataset.nativePackages === 'true' && event.target.closest('.jupityr-dock-packages'))) {
          const select = this.querySelector('secondary-variant-select select');
          const option = Array.from(select?.options || []).find(item => item.value === event.target.value);
          if (option && !option.disabled) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        this.updateSelection();
      }, options);
      document.addEventListener('change', event => {
        if (event.target.closest('quantity-breaks')?.dataset.section === this.dataset.section) this.cleanPrice();
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-dock-close]')) this.close(true);
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close(false);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(true); }
      }, options);
      // Clean only the native price separator, including after variant re-rendering.
      this.priceObserver = new MutationObserver(() => this.cleanPrice());
      this.priceObserver.observe(this.dock.querySelector('.sticky-atc__button'), { childList: true, subtree: true, characterData: true });
      this.visibilityObserver = new MutationObserver(() => {
        if (this.dock.hasAttribute('data-after-scroll') && this.dock.style.transform !== 'none') this.close(false);
      });
      this.visibilityObserver.observe(this.dock, { attributes: true, attributeFilter: ['style'] });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data?.sectionId) !== this.dataset.section || !data.variant) return;
          if (this.dataset.nativePackages === 'true') {
            this.querySelectorAll('.jupityr-dock-packages input').forEach(input => { input.checked = input.dataset.variantId === String(data.variant.id); });
            this.label.textContent = data.variant.title;
            return;
          }
          if (this.dataset.nativeColours === 'true') {
            this.querySelectorAll('.jupityr-dock-finishes input').forEach(input => { input.checked = input.value === data.variant.option1; });
            this.updateSelection();
          } else if (!this.querySelector('.jupityr-dock-packages')) this.label.textContent = data.variant.title;
        });
      }
      this.updateSelection();
      this.cleanPrice();
    }
    cleanPrice() {
      const price = this.dock.querySelector('[id^="sticky-atc-price-"]');
      const breaks = document.getElementById(`quantity-breaks-${this.dataset.section}`);
      const choice = breaks?.querySelector('input[name="quantity"]:checked');
      const total = choice && breaks.querySelector(`label[for="${choice.id}"] .quantity-break__price`);
      const label = total?.textContent.trim() || price?.textContent.replace(/\s*•\s*$/, '').trim();
      if (price && label && price.textContent !== label) price.textContent = label;
    }
    updateSelection() {
      const kit = this.querySelector('.jupityr-dock-packages input:checked');
      if (this.dataset.nativePackages === 'true') {
        if (kit) this.label.textContent = kit.value;
        return;
      }
      const finish = this.querySelector('.jupityr-dock-finishes input:checked');
      if (!kit) return;
      this.label.textContent = [kit.value, finish?.value.replace(/^./, letter => letter.toUpperCase())].filter(Boolean).join(' · ');
      this.querySelector('summary .jupityr-dock-swatch').dataset.finish = finish?.value.toLowerCase() || 'white';
    }
    close(restoreFocus) {
      if (!this.details.open) return;
      this.details.open = false;
      if (restoreFocus) this.summary.focus();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.priceObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.unsubscribe?.();
    }
  });
}
